import { render, staticRenderFns } from "./modaljobdetails.vue?vue&type=template&id=df22d0fa"
import script from "./modaljobdetails.vue?vue&type=script&lang=js"
export * from "./modaljobdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports